module.exports = __webpack_public_path__ + "images/job/detail/detail_icon01-b1eaff4fdb500fc23981bdb2aad11abf.png";